import useReduxAction from '@hooks/useReduxAction'

function useTemplateQualityControlCategories(options: { performHttpRequests: boolean }) {
  const { performHttpRequests } = options

  const { data: templateQualityControlCategories } = useReduxAction(
    'taskListTemplates',
    'loadTemplateQualityControlCategories',
    {},
    [],
    {
      shouldPerformFn: () => performHttpRequests,
    },
  )

  return {
    templateQualityControlCategories,
  }
}

export default useTemplateQualityControlCategories
